export const tabList = ['地方服务', '人才服务', '智库服务', '产业服务'];

export const profile = {
  bg: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/service/service-bg.png',
  bgMD: 'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/service/service-bg-MD.png',
  label: '科普工作',
  subLabel: 'Popularization',
  content:
    '作为科技类社会组织，学会把科普作为重要社会责任，充分发掘专业优势和行业优势，通过打造数字经济巡讲团、开展专项科普活动、创新短视频科普系列等，积极推动新时代科普事业高质量发展。',
};
